<template>
  <div id="issuePage">
    <TopNav
      :height="`${116*$utils.ratio}px`"
      backgroundColor="linear-gradient(139deg, #76DF8A 0%, #42D9A1 43%, #35D092 100%)"
      placeholder="搜索圈子/提问"
      @handleAvatar="$refs.PersonalPopup.show()"
      @search="$router.push({name:'IssueSearch'})"
    />
    <van-tabs
      v-model="active"
      sticky
      :offset-top="`${116*$utils.ratio}px`"
      animated
      swipeable
      @change="tabsChange"
    >
      <van-tab title="推荐">
        <van-pullRefresh v-model="answerDetail.refreshing" @refresh="init('answerDetail')">
          <Empty v-if="answerDetail.totalCount === 0" />
          <van-List
            v-else
            v-model="answerDetail.loading"
            :finished="answerDetail.finished"
            @load="onLoad('answerDetail')"
          >
            <IssueItem
              v-for="(item,index) in answerDetail.list"
              :key="index"
              @click="jumpTo('IssueDetail', item.questionId)"
              :detail="item"
            />
            <template #finished>
              <van-divider class="list-bottom-tip">滑到底啦</van-divider>
            </template>
          </van-List>
        </van-pullRefresh>
      </van-tab>
      <van-tab title="关注">
        <van-pullRefresh v-model="followAnswerDetail.refreshing" @refresh="init('followAnswerDetail')">
          <Empty v-if="followAnswerDetail.totalCount === 0" />
          <van-List
            v-else
            v-model="followAnswerDetail.loading"
            :finished="followAnswerDetail.finished"
            @load="onLoad('followAnswerDetail')"
          >
            <IssueItem
              v-for="(item,index) in followAnswerDetail.list"
              :key="index"
              @click="jumpTo('IssueDetail', item.id)"
              :detail="item"
            />
            <template #finished>
              <van-divider class="list-bottom-tip">滑到底啦</van-divider>
            </template>
          </van-List>
        </van-pullRefresh>
      </van-tab>
      <van-tab title="圈子">
        <van-pullRefresh v-model="circleDetail.refreshing" @refresh="init('circleDetail')">
          <Empty v-if="circleDetail.totalCount === 0" />
          <van-List
            v-else
            v-model="circleDetail.loading"
            :finished="circleDetail.finished"
            @load="onLoad('circleDetail')"
          >
            <CircleItem
              v-for="(item, index) in circleDetail.list"
              :key="index"
              :detail="item"
              @click="jumpTo('CircleDetail', item.id)"
              @handleButton="handleFollow('circleDetail', item)"
            />
            <template #finished>
              <van-divider class="list-bottom-tip">滑到底啦</van-divider>
            </template>
          </van-List>
        </van-pullRefresh>
      </van-tab>
      <template v-if="false">

        <van-tab title="动态">

          <van-pullRefresh v-model="dynamicsDetail.refreshing" @refresh="init('dynamicsDetail')">
            <Empty v-if="dynamicsDetail.totalCount === 0" />
            <van-List
              v-else
              v-model="dynamicsDetail.loading"
              :finished="dynamicsDetail.finished"
              @load="onLoad('dynamicsDetail')"
            >
              <UpdateItem
                v-for="(item, index) in circleDetail.list"
                :key="index"
                :obj="item"
                @click="jumpTo('UpdateDetail',item)"
              />
              <template #finished>
                <van-divider class="list-bottom-tip">滑到底啦</van-divider>
              </template>
            </van-List>
          </van-pullRefresh>
        </van-tab>
      </template>
    </van-tabs>
    <PersonalPopup ref="PersonalPopup" />
    <div class="popoverWrap" v-show="active === 3">
      <van-popover
        v-model="showPopover"
        theme="dark"
        trigger="click"
        placement="top"
      >
        <div class="actions">
          <div class="item" @click="$router.push({name:'WriteUpdate'})">
            <img class="icon" :src="require('@/assets/images/issue/icon_video_01.png')" />
            <span>发动态</span>
          </div>
          <div class="item" @click="$router.push({name:'WriteUpdate'})">
            <img class="icon" :src="require('@/assets/images/issue/icon_image_01.png')" />
            <span>发图片</span>
          </div>
        </div>
        <template #reference>
          <button class="btn" type="primary">
            <img class="icon" :src="require('@/assets/images/issue/icon_edit_01.png')" />
            <span>发动态</span>
          </button>
        </template>
      </van-popover>
    </div>
  </div>
</template>

<script>
import { TopNav, Empty } from '@/components';
import PersonalPopup from '@/views/personal/PersonalPopup';
import IssueItem from './components/IssueItem';
import CircleItem from './components/CircleItem';
import UpdateItem from './components/UpdateItem';
import { Popover } from 'vant';
export default {
  name: 'Issue',
  components: { TopNav, PersonalPopup, Empty, IssueItem, CircleItem, UpdateItem, 'van-popover': Popover },
  data () {
    return {
      active: 0,
      ...(() => {
        const obj = {};
        ['answerDetail', 'followAnswerDetail', 'circleDetail', 'dynamicsDetail'].forEach((item) => {
          obj[item] = {
            list: [],
            pageNo: 1,
            pageSize: 20,
            totalCount: '',
            loading: false,
            finished: false,
            refreshing: false
          };
        });
        return obj;
      })(),
      apiObj: {
        answerDetail: 'community/circle/answer/top/list', // 问答
        followAnswerDetail: 'community/circle/follow/answer/list', // 关注
        circleDetail: 'community/circle/all/list', // 圈子
        dynamicsDetail: 'community/my/dynamics' // 动态，暂时废弃
      },
      showPopover: false
    };
  },
  created () {
    this.active = this.$route.query.active * 1;
  },
  activated () {
    this.tabsChange(this.active);
    const key = ['answerDetail', 'followAnswerDetail', 'circleDetail', 'dynamicsDetail'][this.active];
    !this[key].totalCount && this.init(key);
  },
  methods: {
    init (key) {
      this[key] = {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: false,
        refreshing: false
      };
    },
    onLoad (key) {
      const { apiObj, [key]: detail } = this;
      this.$http.get(apiObj[key], {
        params: {
          pageNo: detail.pageNo,
          pageSize: detail.pageSize
        },
        hideErrorMessage: true
      }).then((res) => {
        let data = res.data || {};
        if (key !== 'dynamicsDetail') {
          data = data.page || {};
        }
        detail.list.push(...(data.result || []));
        detail.pageNo++;
        detail.totalCount = data.totalCount || 0;
        detail.loading = false;
        detail.finished = !data.isHasNext;
        detail.refreshing = false;
      });
    },
    jumpTo (name, id) {
      this.$router.push({
        name,
        query: {
          id
        }
      });
    },
    handleFollow (name, item) {
      if (this.$goToLogin()) {
        let apiUrl = 'community/circle/follow';
        let message = '关注成功';
        if (item.follow) {
          apiUrl = 'community/circle/unFollow';
          message = '已取消关注';
        }
        this.$http.post(apiUrl, {
          id: item.id
        }, {
          showLoading: true,
          loadingText: ' '
        }).then((res) => {
          item.follow = !item.follow;
          item.followers += item.follow ? 1 : -1;
          this.$utils.successToast(message);
        });
      }

    },
    tabsChange (e) {
      this.$router.replace({
        query: { active: e }
      });
    }
  }
};
</script>
<style lang="less" scoped>
  #issuePage{
    /deep/
    .van-tabs{
      .van-tabs__line{
        background-image: url('~@/assets/images/icon_tab_green.png');
      }
      .van-tab--active {
        color: @primaryGreen;
      }
    }
    .popoverWrap {
      width: 184px;
      height: 80px;
      position: fixed;
      top: 988px;
      right: 28px;
      .btn {
        width: 184px;
        height: 80px;
        background: linear-gradient(132deg, #76DF8A 0%, #42D9A1 43%, #35D092 100%);
        border-radius: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        .icon {
          width: 28px;
          height: 28px;
        }
        span {
          margin-left: 12px;
          font-size: 28px;
          font-weight: 400;
          color: #fff;
        }
      }
    }
    .actions {
      width: 184px;
      height: 200px;
      background: #151515;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .item {
        height: 50%;
        display: flex;
        justify-content: center;
        padding: 20px;
        &:nth-child(1) {
          align-items: flex-end;
        }
        &:nth-child(2) {
          align-items: flex-start;
        }
        .icon {
          width: 40px;
          height: 40px;
        }
        span {
          margin-left: 20px;
          font-size: 28px;
          font-weight: 400;
          color: #fff;
        }
      }
    }
  }

</style>